import '../../../resources/css/admin_style.css';
import styles from './component.module.css';
import { useState, useEffect, useCallback, useContext  } from 'react';
import { IAM_SERVER_MULTIFACTORPOLICY } from '../../../utils/Config';
import axios from "../../../utils/api/axios";
import PasswordEditModal from './modal/PasswordEditModal';
import OtpRegisterModal from './modal/OtpRegisterModal';
import PushAuthModal from './modal/PushAuthModal';
// import { DialogEnum, showDialog } from '../../../utils/dialog/Dialog';
import PassKeyAuthModal from './modal/PassKeyAuthModal';
import DetailModal from '../../../utils/modal/DetailModal';
import { ModalContext } from '../../../utils/modal/ModalProvider';
import { Fido2 } from '../../../core/fido2';
import { formatRelativeTime, formatSmartTime } from '../../../utils/date/timeUtils'; 
import { getCookie } from '../../../utils/cookies/cookies';
import { useDialog } from '@intsoft/innocode-core';

function InfoItem({ label, value, onClick }) {
  return (
    <div className={styles.infoItem} onClick={onClick}>
      <span className={styles.infoItemLabel}>{label}</span>
      <span className={styles.infoItemValue}>
        {value || "설정되지 않음"} <span className={styles.editArrow}>&gt;</span>
      </span>
    </div>
  );
}

// 2단계 인증 항목 컴포넌트
function MfaItem({ label, status, isToggled, onToggle, onSetupClick, onManageClick, infoText = null }) {

    let statusTextDisplay;
    let isClickableStatusText = false; // "설정" 텍스트가 클릭 가능한지 여부

    // 상태 텍스트 로직 개선
    if (status === 'DISABLED') {
        statusTextDisplay = "설정"; // 아직 설정되지 않았을 때 "설정" 버튼 역할
        isClickableStatusText = true; // "설정" 텍스트는 클릭 가능
    } else { // status === 'ENABLED'
        statusTextDisplay = isToggled ? "사용" : "미사용"; // 설정되었을 때 토글 상태에 따라 "사용" 또는 "미사용"
        // 이 상태일 때 statusText는 클릭 액션을 가지지 않습니다. 액션은 토글 또는 화살표가 가집니다.
    }

    // 토글 스위치 컴포넌트
    const ToggleSwitch = () => (
        <label className={styles.switch} onClick={(e) => e.stopPropagation()}> {/* 토글 클릭 시 부모 이벤트 전파 방지 */}
            <input type="checkbox" checked={isToggled} onChange={onToggle} />
            <span className={styles.slider}></span>
        </label>
    );

    // 화살표 표시 조건
    const showArrow = (label !== '이메일 인증' && onManageClick); // ENABLED 상태이고, 이메일 인증이 아니며, 관리 클릭 핸들러가 있을 때만 화살표 표시

    return (
        <div className={styles.infoItem} onClick={onManageClick}>
            <span className={styles.infoItemLabel}>{label}</span>
            <span className={styles.infoText}>
                {infoText || (status === 'DISABLED' ? '미설정' : '')}
            </span>
            <div className={styles.mfaControl}>
                {/* 설정된 경우에만 토글 표시 */}
                {status === 'ENABLED' && <ToggleSwitch />} 
                
                {/* "설정" 텍스트 또는 "사용/미사용" 텍스트 */}
                <span 
                    className={`${styles.statusText} ${isClickableStatusText ? styles.statusDisabled : ''}`}
                    onClick={isClickableStatusText ? onSetupClick : undefined} // "설정"일 때만 클릭 이벤트 바인딩
                >
                    {/* {statusTextDisplay} */}
                </span>

                {/* 화살표는 ENABLED 상태이고 이메일 인증이 아니며, onManageClick이 있을 때 표시 */}
                {/* {showArrow && (
                    <span className={styles.editArrow} >&gt;</span>
                )}
                {!showArrow && (
                    <span className={styles.editArrow} ></span>
                )} */}
                <span 
                    className={styles.editArrow}
                    style={{ visibility: showArrow ? 'visible' : 'hidden' }} // 이 라인이 핵심입니다.
                >
                    &gt;
                </span>
            </div>
        </div>
    );
}

function SecurityPanel({ }) {
  const { showDialog } = useDialog();
  const [showModal, setShowModal] = useState(false);
  const {openModal} = useContext(ModalContext);
  const [editField, setEditField] = useState("");
  const [mfaStatus, setMfaStatus] = useState({
      TOTP: 'DISABLED',
      EMAIL_LINK: 'DISABLED',
      PUSH_NOTIFICATION: 'DISABLED',
      KAKAO_MESSAGE: 'DISABLED',
      FIDO2: 'DISABLED'
  });
  
  const [mfaToggles, setMfaToggles] = useState({ // 토글 상태 관리
      TOTP: false,
      EMAIL_LINK: false,
      PUSH_NOTIFICATION: false,
      KAKAO_MESSAGE: false,
      FIDO2: false
  });

  const [mfaPolicy, setMfaPolicy] = useState({}); 
  const [otpInfoText, setOtpInfoText] = useState(""); // OTP 연결 설정일
  const [emailLink, setEmailLink] = useState(""); // 이메일 인증
  const [pushDevices, setPushDevices] = useState([]); // Push 연결 기기 목록 상태
  const [fido2Devices, setFido2Devices] = useState(""); // FIDO2 기기 수 상태

   // ✅ 이메일 MFA 정책을 자동으로 등록하는 함수
  const registerEmailMfaPolicy = useCallback(async (unifiedProfileId) => {
      try {
          const res = await axios.post(`${IAM_SERVER_MULTIFACTORPOLICY}/create`, {
              factorType: 'EMAIL_LINK',
              factorPolicyName: 'EMAIL Policy',
              unifiedProfileId: unifiedProfileId,
              status: false, // 기본적으로 활성화 상태로 등록
              factorPolicyMeta: {} // 필요한 경우 메타데이터 추가
          });
          if (res.data.data) {
              // 등록 성공 후 상태를 다시 불러와 UI를 업데이트
              fetchMfaStatus(); 
          } else {
              console.error('Failed to register EMAIL_LINK MFA policy:', res.data.resultMessage);
              showDialog({
                iconType: "warning",
                type: 'error',
                title: "오류",
                message: "이메일 2단계 인증 정책 등록에 실패했습니다.",
                confirmText: "확인",
            });

            //   showDialog(DialogEnum.ERROR, "오류", "이메일 2단계 인증 정책 등록에 실패했습니다.");
          }
      } catch (error) {
          console.error('Error during EMAIL_LINK MFA policy registration:', error);
          showDialog({
            iconType: "warning",
            type: 'error',
            title: "오류",
            message: "이메일 2단계 인증 정책 등록 중 서버 오류가 발생했습니다.",
            confirmText: "확인",
        });
        //   showDialog(DialogEnum.ERROR, "오류", "이메일 2단계 인증 정책 등록 중 서버 오류가 발생했습니다.");
      }
  }, []); // 의존성 배열 비워 useCallback 안정화


    // 🔑 MFA 설정 상태를 가져오는 함수
  const fetchMfaStatus = async () => {
      // TODO: 사용자 ID를 가져와야 함 (AuthContext 등에서)
    const unifiedProfileId = getCookie('user_id');
      
    const conditions = [
      { field: "unifiedProfileId", operator: "EQUALS", value: unifiedProfileId },
    ];

    // 최종 params 구성
    const params = {
        page: 0,
        size: 0,
        sortField: ["createdDate"],
        sortOrder: ["desc"],
        operator: "AND",
        conditions
    };


    try {
        const res = await axios.post(`${IAM_SERVER_MULTIFACTORPOLICY}/all`, params);
        const { data } = res.data.data;

        const processingPromises = data.map(async (policy) => {
            if (policy.factorType === 'FIDO2') {
                const result = await Fido2.findUserNameCredentials(unifiedProfileId);
                const resultJson = JSON.parse(result);
                const text = resultJson.credentials.length > 0 ? `${resultJson.credentials.length} 대` : '';
                
                // 비동기 작업의 결과와 policy를 함께 반환
                return { policy, fidoDevicesText: text };
            }
            // 비동기 작업이 없는 경우
            return { policy, fidoDevicesText: null };
        });

        const processedResults = await Promise.all(processingPromises);
        
        const newStatus = {
            TOTP: 'DISABLED',
            EMAIL_LINK: 'DISABLED',
            PUSH_NOTIFICATION: 'DISABLED',
            KAKAO_MESSAGE: 'DISABLED',
            FIDO2: 'DISABLED'
        };
        const newToggles = { 
            TOTP: false,
            EMAIL_LINK: false,
            PUSH_NOTIFICATION: false,
            KAKAO_MESSAGE: false,
            FIDO2: false
        };
        const newPolicyMap = {};
        
        let isEmailLinkPolicyFound = false; // 이메일 링크 정책이 있는지 추적

        processedResults.forEach(({ policy, fidoDevicesText }) => {
            newStatus[policy.factorType] = 'ENABLED';
            newToggles[policy.factorType] = policy.status;
            newPolicyMap[policy.factorType] = policy; 

            if (policy.factorType === 'TOTP' && policy.factorPolicyMeta) {
                const dateText = formatSmartTime(policy.createdDateView); // 함수를 직접 호출
                setOtpInfoText(dateText ? `${dateText} 설정됨` : '설정됨');
            } else if (policy.factorType === 'EMAIL_LINK') {
                isEmailLinkPolicyFound = true;
                setEmailLink(policy.unifiedProfileId);
            } else if (policy.factorType === 'PUSH_NOTIFICATION' /*...*/) {
                setPushDevices(policy.factorPolicyMeta.devices);
            } else if (policy.factorType === 'FIDO2') {
                // 비동기 처리 결과를 여기서 사용
                setFido2Devices(fidoDevicesText);
            }
        });

        // ✅ EMAIL_LINK 정책이 없으면 자동으로 등록
        if (!isEmailLinkPolicyFound) {
            await registerEmailMfaPolicy(unifiedProfileId);
            // registerEmailMfaPolicy 내부에서 fetchMfaStatus를 다시 호출하여
            // UI를 업데이트하므로 여기서는 추가적인 setMfaStatus 호출을 피합니다.
            return; // 자동 등록 후에는 이 함수의 나머지 실행을 중단하고 다시 불러온 데이터로 처리
        }

        setMfaPolicy(newPolicyMap);
        setMfaStatus(newStatus);
        setMfaToggles(newToggles); 

    } catch (error) {
        console.error('MFA 정책 조회 또는 처리 실패:', error);
        //showDialog(DialogEnum.ERROR, "오류", "MFA 정보를 가져오는 데 실패했습니다.");
    }
  };

  useEffect(() => {
      fetchMfaStatus();
  }, []);

  const handleEdit = (field) => {
    setEditField(field);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditField("");
    fetchMfaStatus();
    // closeModal();
  };


  const handleToggle = async (factorType) => {
    const currentToggleStatus = mfaToggles[factorType];
    setMfaToggles(prevToggles => ({
        ...prevToggles,
        [factorType]: !currentToggleStatus
    }));

    const policy = mfaPolicy[factorType];

    if (policy) {
        const newStatus = !currentToggleStatus;
        try {
            const res = await axios.post(`${IAM_SERVER_MULTIFACTORPOLICY}/update/status`, {
                multiFactorPolicyId: policy.multiFactorPolicyId,
                status: newStatus,
            });

           if (res.data.data) {
                fetchMfaStatus(); // API 성공 시, 실제 상태를 다시 불러와 UI를 안정화
                showDialog({
                    iconType: "check",
                    type: 'info',
                    title: `작업 성공`,
                    message: `${labelMap[factorType]} 2단계 인증이\n${newStatus ? '활성화' : '비활성화'} 되었습니다.`,
                    confirmText: "확인",
                });
                // showDialog(DialogEnum.SUCCESS, "성공", `${labelMap[factorType]} 2단계 인증이 ${newStatus ? '활성화' : '비활성화'} 되었습니다.`);
            } else {
                // API 실패 시, UI 상태를 원래대로 되돌림 (rollback)
                setMfaToggles(prevToggles => ({
                    ...prevToggles,
                    [factorType]: currentToggleStatus // 이전 상태로 되돌림
                }));
                console.error("MFA 상태 변경 실패:", res.data.resultMessage);
                showDialog({
                    iconType: "warning",
                    type: 'error',
                    title: `작업 실패`,
                    message: res.data.resultMessage || `${labelMap[factorType]} 2단계 인증 상태\n변경에 실패했습니다.`,
                    confirmText: "확인",
                });
                // showDialog(DialogEnum.ERROR, "실패", res.data.resultMessage || `${labelMap[factorType]} 2단계 인증 상태 변경에 실패했습니다.`);
            }
        } catch (error) {
            console.error("API 호출 중 오류 발생:", error);
            setMfaToggles(prevToggles => ({
                ...prevToggles,
                [factorType]: !prevToggles[factorType]
            }));
        }
    } else {
        console.error("해당 MFA 정책을 찾을 수 없습니다.");
    }
  };

  const labelMap = {
    password: "비밀번호",
    TOTP: "OTP",
    EMAIL_LINK: "이메일",
    PUSH_NOTIFICATION: "앱 푸시 알림",
    KAKAO_MESSAGE: "카카오톡 메시지",
    FIDO2: "패스키",
  };

  return (
    <div className={styles.infoCardWrapper}>
        <div className={styles.infoCard}>
            <h2 className={styles.infoTitle}>Innocode에 로그인하는 방법</h2>
            <h3 className={styles.infoSubTitle}>항상 Innocode 계정에 액세스할 수 있도록 최신 정보가 반영되었는지 확인하세요.</h3>
                    <InfoItem
                        label={labelMap.password}
                        value={"********"}
                        onClick={() => handleEdit("password")}
                    />  
            </div>
            <div className={styles.infoCard}>
                <h2 className={styles.infoTitle}>2단계 인증</h2>
                    <h3 className={styles.infoSubTitle}>계정 보안을 강화하기 위해 2단계 인증을 설정하세요.</h3>

                    <MfaItem 
                        label={labelMap.TOTP}
                        status={mfaStatus.TOTP}
                        isToggled={mfaToggles.TOTP} 
                        onToggle={() => handleToggle('TOTP')} 
                        onSetupClick={() => handleEdit('TOTP')} // 'DISABLED' 상태일 때 호출 (등록 모달)
                        onManageClick={() => handleEdit('TOTP')} // 'ENABLED' 상태일 때 호출 (관리 모달)
                        infoText={mfaStatus.TOTP === 'ENABLED' ? `${otpInfoText}` : `${otpInfoText}`}
                    />
                    <MfaItem 
                        label={labelMap.EMAIL_LINK}
                        status={mfaStatus.EMAIL_LINK}
                        infoText={mfaStatus.EMAIL_LINK === 'ENABLED' ? `${emailLink}` : null}
                        isToggled={mfaToggles.EMAIL_LINK}
                        onToggle={() => handleToggle('EMAIL_LINK')}
                        // ✅ 이메일 인증은 onSetupClick, onManageClick 모두 필요 없거나 null로 전달합니다.
                        // onSetupClick={null} // 자동 등록이므로 필요 없음
                        // onManageClick={null} // 화살표도 필요 없으므로 null 또는 생략
                    />
                    <MfaItem 
                        label={labelMap.FIDO2}
                        status={mfaStatus.FIDO2}
                        isToggled={mfaToggles.FIDO2} 
                        onToggle={() => handleToggle('FIDO2')} 
                        onSetupClick={() => handleEdit('FIDO2')} // 'DISABLED' 상태일 때 호출 (등록 모달)
                        onManageClick={() => handleEdit('FIDO2')} // 'ENABLED' 상태일 때 호출 (관리 모달)
                        // onSetupClick={passKeyAuthModal} // 'DISABLED' 상태일 때 호출 (등록 모달)
                        // onManageClick={passKeyAuthModal} // 'ENABLED' 상태일 때 호출 (관리 모달)
                        infoText={mfaStatus.FIDO2 === 'ENABLED' ? `${fido2Devices}` : null}
                    />
                    {/* <MfaItem 
                        label={labelMap.PUSH_NOTIFICATION}
                        status={mfaStatus.PUSH_NOTIFICATION}
                        onClick={() => handleEdit("PUSH_NOTIFICATION")}
                        infoText={mfaStatus.TOTP === 'ENABLED' ? `기기 ${pushDevices.length}대` : null} // infoText로 기기 수를 전달
                    /> */}
                    {/* <MfaItem 
                        label={labelMap.KAKAO_MESSAGE}
                        status={mfaStatus.KAKAO_MESSAGE}
                        onClick={() => handleEdit("KAKAO_MESSAGE")}
                    /> */}

                    
                    {editField === 'password' && showModal && (
                        <PasswordEditModal onClose={closeModal} onSuccess={closeModal}/>
                    )}
                    {editField === 'TOTP' && showModal && (
                    <OtpRegisterModal 
                        onClose={closeModal} 
                        onSuccess={closeModal}
                    />
                    )}
                    {editField === 'FIDO2' && showModal && (
                        <PassKeyAuthModal onClose={closeModal} onSuccess={closeModal}/>
                    )}
            </div>
    </div>
    
  );
}

export default SecurityPanel;
